import React from 'react'
import { StateProvider } from '@State'
import { peopleReducer, defaultState } from '../reducers'
import { FilterContainer } from './FilterContainer'
import { LinksContainer } from './LinksContainer'
import { PeopleContainer } from './PeopleContainer'
import { Toaster } from '@CommonComponents/toast'

export const App = ({
  courseData,
  peopleData,
  archivedData,
  sectionData,
  allSectionData,
  peopleCount,
  archivedCount,
  sectionCount,
  elevatedUser,
  chapterData,
  videoData,
  supportDashboard,
}) => {
  const initialState = {
    ...defaultState,
    coursenum: courseData['coursenum'],
    courseTitle: courseData['courseTitle'],
    courseLms: courseData['courseLms'] === 'true',
    authorized: courseData['authorized'] === 'true',
    peopleRowData: peopleData,
    archivedRowData: archivedData,
    sectionRowData: sectionData,
    allSectionData: allSectionData,
    peopleCount: peopleCount,
    archivedCount: archivedCount,
    sectionCount: sectionCount,
    elevatedUser: elevatedUser,
    chapterData: chapterData,
    videoData: videoData,
    supportDashboard: supportDashboard,
    daysOfAccess: courseData['daysOfAccess'],
  }

  return (
    <StateProvider initialState={initialState} reducer={peopleReducer}>
      <div
        id="body_section"
        className="d-flex mt-5"
        style={{ minHeight: '100vh' }}
      >
        <Toaster />
        <div
          className="contentLeft maxw-300px w-100 ml-5"
          style={{ flexShrink: 0 }}
        >
          <div>
            <FilterContainer />
          </div>
          <div>
            <LinksContainer />
          </div>
        </div>
        <div className="mainContent ml-5" style={{ flex: 1, minWidth: 0 }}>
          <PeopleContainer />
        </div>
      </div>
    </StateProvider>
  )
}
